<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onlineUsersRef, rtdb } from '@/firebase-config';
import { useAuthStore } from '@/stores/auth-store';
import { onDisconnect, onValue, ref } from 'firebase/database';

const authStore = useAuthStore();

const connectedRef = ref(rtdb, '.info/connected');

onValue(connectedRef, (snap) => {
  if (snap.val() === true) {
    const presenceRef = onlineUsersRef(authStore.currentUser?.uid ?? 'null');
    onDisconnect(presenceRef).remove();
  }
});
</script>

<style scoped></style>
